import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const dueSwitch = css`
  margin-block-start: ${spacing(1)};
`

export const dueSettings = css`
  margin-block-start: ${spacing(2)};
  display: flex;

  & > *:not(:last-child) {
    margin-inline-end: ${spacing(1)};
  }
`

export const offersBody = css`
  padding: ${spacing(1, 3, 2, 1)};

  & > *:first-child {
    padding-inline-start: 0;
  }
`
